(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ttft-waveform-player"] && !Shopify.designMode) return;
  try {
    (() => {
  const configNode = document.querySelector('[data-ttft-wave-config]');
  if (!configNode) return;
  let config;
  try { config = JSON.parse(configNode.textContent); } catch (_) { return; }
  const labels = config.labels;
  const namespace = 'http://www.w3.org/2000/svg';
  let sequence = 0;
  const formatTime = value => {
    const seconds = Math.max(0, Math.floor(Number.isFinite(value) ? value : 0));
    return `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}`;
  };
  const element = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  };
  const svgElement = (tag, attributes) => {
    const node = document.createElementNS(namespace, tag);
    Object.entries(attributes).forEach(([key, value]) => node.setAttribute(key, value));
    return node;
  };
  document.addEventListener('play', event => {
    if (!(event.target instanceof HTMLAudioElement)) return;
    document.querySelectorAll('audio').forEach(other => {
      if (other !== event.target && !other.paused) other.pause();
    });
  }, true);
  const enhance = audio => {
    if (audio.dataset.ttftWave) return;
    const source = audio.getAttribute('src') || audio.querySelector('source')?.getAttribute('src');
    const data = config.tracks[source];
    if (!data || !Array.isArray(data.peaks) || data.peaks.length < 2 || !(data.duration > 0)) return;
    const header = audio.previousElementSibling;
    const titleNode = header?.children[1]?.children[0];
    const artistNode = header?.children[1]?.children[1];
    const title = titleNode?.textContent.trim() || config.title;
    const side = header?.children[0]?.textContent.trim() || '';
    const trackName = `${side} ${title}`.trim();
    const ui = element('div', 'ttft-wave-ui');
    ui.setAttribute('role', 'group');
    ui.setAttribute('aria-label', `${labels.preview}: ${trackName}`);
    const controls = element('div', 'ttft-wave-controls');
    const play = element('button', 'ttft-wave-play');
    play.type = 'button';
    play.setAttribute('aria-label', `${labels.play}: ${trackName}`);
    play.setAttribute('aria-pressed', 'false');
    const icon = svgElement('svg', {viewBox:'0 0 24 24', 'aria-hidden':'true', focusable:'false'});
    icon.append(svgElement('path', {d:'M7 4.5v15L20 12z', class:'ttft-wave-play-icon'}));
    icon.append(svgElement('path', {d:'M6 5h4v14H6zm8 0h4v14h-4z', class:'ttft-wave-pause-icon'}));
    play.append(icon);
    const scrub = element('div', 'ttft-wave-scrub');
    const svg = svgElement('svg', {viewBox:'0 0 512 64', preserveAspectRatio:'none', class:'ttft-wave-svg', 'aria-hidden':'true', focusable:'false'});
    const clipId = `ttft-wave-clip-${++sequence}`;
    const defs = svgElement('defs', {});
    const clip = svgElement('clipPath', {id:clipId, clipPathUnits:'userSpaceOnUse'});
    const clipRect = svgElement('rect', {x:'0', y:'0', width:'0', height:'64'});
    clip.append(clipRect); defs.append(clip);
    const base = svgElement('path', {class:'ttft-wave-base'});
    const progress = svgElement('path', {class:'ttft-wave-progress', 'clip-path':`url(#${clipId})`});
    svg.append(defs, base, progress);
    const seek = element('input', 'ttft-wave-range');
    seek.type = 'range'; seek.min = '0'; seek.max = String(data.duration); seek.step = '0.1'; seek.value = '0';
    seek.setAttribute('aria-label', `${labels.seek}: ${trackName}`);
    const times = element('div', 'ttft-wave-times');
    const current = element('span', '', '0:00');
    const length = element('span', '', formatTime(data.duration));
    const hint = element('span', 'ttft-wave-hint', labels.hint);
    times.setAttribute('aria-hidden', 'true');
    times.append(current, hint, length);
    const status = element('p', 'ttft-wave-status');
    status.setAttribute('role', 'status');
    scrub.append(svg, seek); controls.append(play, scrub); ui.append(controls, times, status);
    let pendingSeek = null;
    let frame = 0;
    const duration = () => Number.isFinite(audio.duration) && audio.duration > 0 ? audio.duration : data.duration;
    const update = () => {
      const total = duration();
      const now = Math.min(total, pendingSeek === null ? audio.currentTime : pendingSeek);
      seek.max = String(total); seek.value = String(now);
      clipRect.setAttribute('width', String(512 * now / total));
      current.textContent = formatTime(now); length.textContent = formatTime(total);
      seek.setAttribute('aria-valuetext', `${formatTime(now)} / ${formatTime(total)}`);
    };
    const paint = () => {
      const width = scrub.getBoundingClientRect().width;
      if (!width) return;
      const count = Math.max(32, Math.min(data.peaks.length, Math.floor(width / 3.5)));
      const unit = 512 / count;
      let path = '';
      for (let index = 0; index < count; index++) {
        const start = Math.floor(index * data.peaks.length / count);
        const end = Math.floor((index + 1) * data.peaks.length / count);
        let peak = 0;
        for (let j = start; j < end; j++) peak = Math.max(peak, data.peaks[j]);
        const height = Math.max(1, peak / 1000 * 54);
        const x = index * unit + unit * .18;
        const y = (64 - height) / 2;
        const bar = unit * .64;
        path += `M${x.toFixed(2)} ${y.toFixed(2)}h${bar.toFixed(2)}v${height.toFixed(2)}h-${bar.toFixed(2)}z`;
      }
      base.setAttribute('d', path); progress.setAttribute('d', path);
    };
    const animate = () => {
      update();
      if (!audio.paused && !audio.ended && audio.isConnected) frame = requestAnimationFrame(animate);
    };
    const setPlaying = playing => {
      play.setAttribute('aria-pressed', String(playing));
      play.setAttribute('aria-label', `${playing ? labels.pause : labels.play}: ${trackName}`);
      cancelAnimationFrame(frame);
      if (playing) animate(); else update();
    };
    const start = () => {
      status.textContent = '';
      audio.play().catch(error => {
        if (error.name === 'AbortError') return;
        status.textContent = error.name === 'NotAllowedError' ? labels.retry : labels.error;
        setPlaying(false);
      });
    };
    play.addEventListener('click', () => {
      if (audio.paused) { if (audio.ended) audio.currentTime = 0; start(); }
      else audio.pause();
    });
    const seekTo = seconds => {
      const value = Math.max(0, Math.min(duration(), seconds));
      if (audio.readyState === 0) {
        pendingSeek = value;
        if (audio.preload === 'none') { audio.preload = 'metadata'; audio.load(); }
      } else { pendingSeek = null; audio.currentTime = value; }
      update();
    };
    seek.addEventListener('input', () => seekTo(Number(seek.value)));
    seek.addEventListener('keydown', event => {
      const now = pendingSeek === null ? audio.currentTime : pendingSeek;
      const targets = {ArrowLeft:now - 5, ArrowDown:now - 5, ArrowRight:now + 5, ArrowUp:now + 5, Home:0, End:duration()};
      if (event.key in targets) { event.preventDefault(); seekTo(targets[event.key]); }
    });
    audio.addEventListener('loadedmetadata', () => {
      if (pendingSeek !== null) { const target = pendingSeek; pendingSeek = null; audio.currentTime = Math.min(duration(), target); }
      update();
    });
    audio.addEventListener('play', () => setPlaying(true));
    audio.addEventListener('pause', () => setPlaying(false));
    audio.addEventListener('ended', () => setPlaying(false));
    audio.addEventListener('timeupdate', update);
    audio.addEventListener('durationchange', update);
    audio.addEventListener('waiting', () => { status.textContent = labels.loading; });
    audio.addEventListener('playing', () => { status.textContent = ''; });
    audio.addEventListener('canplay', () => { status.textContent = ''; });
    audio.addEventListener('error', () => {
      audio.classList.remove('ttft-wave-native'); audio.controls = true;
      status.textContent = labels.error;
      setPlaying(false);
    });
    audio.after(ui);
    audio.dataset.ttftWave = '1';
    audio.controls = false;
    audio.classList.add('ttft-wave-native');
    const card = audio.parentElement;
    card.classList.add('ttft-wave-track');
    card.parentElement.classList.add('ttft-wave-grid');
    card.parentElement.parentElement.classList.add('ttft-wave-release');
    header?.classList.add('ttft-wave-heading');
    titleNode?.classList.add('ttft-wave-title');
    artistNode?.classList.add('ttft-wave-artist');
    paint(); update();
    if ('ResizeObserver' in window) new ResizeObserver(paint).observe(scrub);
  };
  const initialize = () => document.querySelectorAll('.product__description audio').forEach(enhance);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true});
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
  } catch(e) { console.error(e); }
})();

})();
